export const LANCAMENTO = 'LANÇAMENTO'
export const NA_PLANTA = 'NA PLANTA'
export const EM_OBRAS = 'EM OBRAS'
export const PRONTO_PARA_MORAR = 'PRONTO PARA MORAR'
